import React, { Fragment, useState, useEffect } from "react";
import GLSLCanvas from "./GLSLCanvas";
import end_frag from "../fragments/smoke";

const Finished = () => {
  const [uniforms] = useState({});
  const [frag, setFrag] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setFrag(end_frag);
    setIsLoading(false);
  }, []);

  return (
    <Fragment>
      {!isLoading && <GLSLCanvas
            class="canvasContainerFull"
            canvasClass="canvasFull"
            frag={frag}
            setUniforms={uniforms}/>}
    </Fragment>
  );
};

export default Finished;
